import { useAuth } from '@/core/AuthContext';
import { ProfileSection } from './settings/ProfileSection';
import { NotificationSection } from './settings/NotificationSection';
import { AppearanceSection } from './settings/AppearanceSection';
import { SubscriptionSection } from './settings/SubscriptionSection';
import { DangerZone } from './settings/DangerZone';
import { TrainerSettingsSection } from './settings/TrainerSettingsSection';

export function Settings() {
  // Test E2E validation: Pipeline check GROU-063

  const { userData } = useAuth();
  const isClient = userData?.role === 'client';

  return (
    <div className="p-6 max-w-4xl mx-auto flex flex-col gap-6" data-testid="settings">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Settings</h1>
        <p className="text-gray-600 dark:text-slate-400">
          Manage your account and preferences
        </p>
      </div>

      {isClient && <SubscriptionSection />}

      <NotificationSection />

      <ProfileSection />

      <AppearanceSection />

      {isClient && <TrainerSettingsSection />}

      <DangerZone />
    </div>
  );
}
